<template>
  <div
    :class="{ 'visible': isOpen }"
    class="modal-wrapper medium-width"
  >
    <div class="modal">
      <div class="modal-header">
        <h2 class="is-size-5">
          Request assistance
        </h2>
      </div>
      <div class="modal-body">
        <div class="columns">
          <div class="column">
            <p>If you've encountered an issue with the recorded video or experienced a malfunction with your device, click the button below to notify us. We'll review your submission and get in touch with you within 24 hours.</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a
          href="#"
          class="button is-dark"
          @click.prevent="closeModal(false)"
        >Close</a>
        <a
          href="#"
          class="button is-primary"
          @click.prevent="requestSupport"
        >Request support</a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'IssueModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    divisionName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      sending: false
    }
  },
  methods: {
    requestSupport () {
      this.sending = true
      let user = this.$store.getters['users/currentUser']
      this.$store
        .dispatch('users/REQUEST_SUPPORT', {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          divisionName: this.divisionName
        })
        .then(() => {
          this.$toasted.success('Your request has been sent')
          this.closeModal()
          this.sending = false
        })
        .catch((err) => {
          this.$toasted.error('There was an issue sending your request')
          this.sending = false
        })
    },
    closeModal () {
      this.$emit('closeModal')
    }
  }
}
</script>
